import Contact from "@/components/Contact";
import FindUs from "@/components/FindUs";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

export default function ContactPage() {
    return (
        <div className="bg-cream text-ink" data-testid="contact-page">
            <Seo
                title="Contact & Directions | Agastya Chiro and Ancient Marma Therapy, Kurnool"
                description="Contact Agastya Chiro and Ancient Marma Therapy — H.No: 87-1299, Road No. 6A, Nagi Reddy Revenue Colony, near Vastralaya Mall, Kurnool 518002. Call 89781 33934. Open Mon–Sat, 9 AM – 6 PM."
                path="/contact"
            />
            <Header />
            <main className="pt-[88px]">
                <div className="mx-auto max-w-7xl px-4 pt-14 sm:px-6 lg:px-8">
                    <p className="text-xs font-semibold uppercase tracking-[0.28em] text-terracotta">Get in Touch</p>
                    <h1
                        className="mt-4 max-w-3xl font-serif text-4xl font-medium leading-[1.05] tracking-tight md:text-5xl"
                        data-testid="contact-page-heading"
                    >
                        Contact Agastya Chiro and Ancient Marma Therapy
                    </h1>
                    <p className="mt-5 max-w-2xl text-sm leading-relaxed text-moss md:text-base">
                        Call, WhatsApp, or visit us in Nagi Reddy Revenue Colony, near Vastralaya Mall,
                        Kurnool. No forms, no waiting — just a direct conversation.
                    </p>
                </div>
                <Contact />
                <FindUs />
            </main>
            <Footer />
        </div>
    );
}
